import { TeamGridItem } from '@sapientpro/sapientpro-data-models';
import styles from './TeamValues.module.scss';
import TeamValueItem from './TeamValuesItem';

interface ITeamValuesGridProps {
  items: TeamGridItem[]
  changeActive: (video: TeamGridItem) => void;
  handleHover: (itemId: number | null) => void;
  hoveredId: number | null;
}

const TeamValuesGrid = ({
  items, changeActive, handleHover, hoveredId,
}: ITeamValuesGridProps) => (
  <div className={styles.teamReviews}>
    {
        items.map(item => (
          <TeamValueItem
            key={item.id}
            item={item}
            changeActive={() => changeActive(item)}
            handleHover={handleHover}
            activeId={hoveredId}
          />
        ))
    }
  </div>
);

export default TeamValuesGrid;
